export default {"src":"/_next/static/image/public/images/ic_hamburger.12ecc10532977d1a25df776a8fb3414e.svg","height":13,"width":18};